import { ISimpleTableCellRenderProps } from "@asup/simple-table";
import { HierarchyBrowserContext } from "components/hierarchybrowser/HierarchyBrowserContext";
import { HierarchyContext } from "contexts/HierarchyContext";
import { ITlfItemRelationship } from "functions/api/tlfItem/TlfItemIndexReadDto";
import { useContext } from "react";
import { eHierarchyLevel, eLinkType, eReleaseStatus } from "../../../functions/api/enums";

/**
 * Table cell renderer that displays hierarchy locations where TLF versions exist.
 *
 * @param props - The component props
 * @param props.rowData - Row data containing TLF item relationships
 */
export const TlfItemVersions = ({ rowData }: ISimpleTableCellRenderProps) => {
  const hierarchyContext = useContext(HierarchyContext);
  const hbc = useContext(HierarchyBrowserContext);

  // Get hierarchy from the correct context
  const currentItem = hbc?.state.treeList.find((h) => h.id === hbc.state.currentHierarchy);

  const hierarchyLevel: eHierarchyLevel | undefined =
    // PrimaryHierarchyLevel really should be set, but just in case
    (rowData.primaryHierarchyLevel as eHierarchyLevel | undefined) ??
    // check HierarchyBrowserContext first
    (hbc && currentItem?.data
      ? currentItem.data.level
      : // Then check hierarchyContext
        hierarchyContext?.hierarchy?.level);

  const links = (rowData["relationships"] as ITlfItemRelationship[] | undefined)?.filter(
    (r) => r.linkType === eLinkType.HasVersion && r.linkStatus !== eReleaseStatus.Retired,
  );

  let linkLocations: string[] = [];
  links?.forEach((link) => {
    /* istanbul ignore else */
    if (
      link.linkLocation?.linkHierarchyName !== undefined &&
      hierarchyLevel === eHierarchyLevel.Corporate
    ) {
      linkLocations.push(link.linkLocation?.linkHierarchyName);
    }
    linkLocations = Array.from(new Set(linkLocations));
  });

  return <>{linkLocations.sort((a, b) => a.localeCompare(b)).join(",")}</>;
};

TlfItemVersions.displayName = "TlfItemVersions";
